import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="37" height="38" {...props}><text transform="translate(0 37)" fill="#fff" fontSize="37" fontFamily="MaterialIcons-Regular, Material Icons"><tspan x="0" y="0">attach_money</tspan></text></svg>);